/**
 * @generated SignedSource<<b2f1c4f2f724a1222d28f2ac0e5b42cb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IssueTypeIndicator$data = {
  readonly issueType: {
    readonly id: string;
    readonly isEnabled: boolean;
    readonly name: string;
  } | null | undefined;
  readonly number: number;
  readonly viewerCanSeeIssueType: boolean;
  readonly " $fragmentType": "IssueTypeIndicator";
};
export type IssueTypeIndicator$key = {
  readonly " $data"?: IssueTypeIndicator$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueTypeIndicator">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IssueTypeIndicator",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "number",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "IssueType",
      "kind": "LinkedField",
      "name": "issueType",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isEnabled",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanSeeIssueType",
      "storageKey": null
    }
  ],
  "type": "Issue",
  "abstractKey": null
};

(node as any).hash = "1674fa8513f68724c686fb8d914d1c71";

export default node;
